import type { TestContext, TestFunction } from 'yup';

export const isCorrectUnitCode: TestFunction = async (value, testContext) => {
  const context = testContext.parent ? testContext : (testContext.options.context as TestContext);
  const isValid = /^\d{6}$/.test(String(value).replace(/\D/g, ''));
  return isValid || context.createError({ path: context.path, message: 'Укажите корректный код' });
};
